export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
export const ALLOWED_DOMAIN = 'mactai.com';